import CadicaScan from './CadicaScan'

export default CadicaScan